import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NotificationDetailsComponent from '../components/notificationDetailsComponent'; 
import {  getAllRegionSettings,fetchNotificationSettings,
       updateNotificationSettings,
       deleteNotificationSettings,
       fetchNotificationTypes,fetchNotificationCategory,fetchFontType
     }from '../action/notificationAction'; 
class NotificationDetailsContainer extends Component {
    constructor(props) {
        super(props);
        this.updateNotificationSettings = this.updateNotificationSettings.bind(this);
        this.deleteNotificationSettings = this.deleteNotificationSettings.bind(this);
        
    }

    componentDidMount() {
        this.props.actions.fetchFontType( 
            this.props.dispatch
        ) 
        this.props.actions.fetchNotificationTypes( 
            this.props.dispatch
        ) 
        this.props.actions.fetchNotificationCategory( 
         this.props.dispatch
     ) 
           /* this.props.actions.fetchNotificationSettings( 
                   this.props.dispatch
               ) */ 
              this.props.actions.getAllRegionSettings();
    }
  getUserList = (data) =>{
                         this.props.actions.fetchNotificationSettings(data,
                             this.props.dispatch
                         )
                     }
                          getRegionData = () => {
                                              this.props.actions.getAllRegionSettings(this.props.dispatch);
                                           } 
    updateNotificationSettings(formData,region) { 
        this.props.actions.updateNotificationSettings(
            this.props.notificationSettings.isLoading,
            formData,region,
            this.props.dispatch
        ) 
    }

    deleteNotificationSettings(notificationSettingsID,RegionId) { 
        this.props.actions.deleteNotificationSettings(
            this.props.notificationSettings.isLoading,
            notificationSettingsID,RegionId,
            this.props.dispatch
        ) .then(res => {
                            console.log('f', res)
                           
                          this.props.actions.fetchNotificationSettings({RegionId:RegionId},
                             this.props.dispatch
                         )
                
                        });;
    }
    
    render() {
        return (
            <div className="agile-grids">
                <div className="grids">
                    <div className="container">
                        <div className="row"> 
                            <NotificationDetailsComponent                                 
                                 updateNotificationSettings={this.updateNotificationSettings}
                                notificationSettings={this.props.notificationSettings}
                                deleteNotificationSettings={this.deleteNotificationSettings}
                                statusCode={this.props.notificationSettings.statusCode} 
                                  getRegionList={this.getRegionData}
                    getUserList ={this.getUserList}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            fetchNotificationSettings,
            updateNotificationSettings,
            deleteNotificationSettings,
            fetchNotificationTypes,
            fetchNotificationCategory,
            fetchFontType,
            getAllRegionSettings
        }, dispatch)
    };
};

function mapStateToProps({ notificationReducer }) {
    return {
        notificationSettings: {
            isLoading: notificationReducer.isLoading,
            notificationType: notificationReducer.notificationType,
            notificationList: notificationReducer.notificationList,
            statusCode: notificationReducer.statusCode,
            errorMessage: notificationReducer.errorMessage,
            messageLabel: notificationReducer.messageLabel,
            notificationCategory:notificationReducer.notificationCategory,
            fontType:notificationReducer.fontType,
            regionList :notificationReducer.regionList,
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NotificationDetailsContainer))